// @flow
import React from 'react';
import {FormattedMessage} from 'react-intl';
import {useDispatch} from 'react-redux';
import {LOCATION__16} from '@homeaway/svg-defs';

import IconButton from '../IconButton/IconButton';
import routerActions from '../../actions/router';
import {trigger, GENERIC_EVENT} from '../../utils/edapWrapper';
import {media} from '../../utils/breakpoints';

import type {Breakpoint} from '../../utils/breakpoints';

type Props = {
    breakpoint: Breakpoint
};

const MetaMapButton = (props: Props) => {
    const dispatch = useDispatch();
    const {breakpoint} = props;

    const showMapIcon =
        !media(breakpoint, {minWidth: 'MD_MIN'}) &&
        media(breakpoint, {minWidth: 'SM_MIN'});

    if (!showMapIcon) {
        return <div className="MetaMapButton" />;
    }

    const handleMapButtonClick = () => {
        trigger(GENERIC_EVENT, {
            eventcategory: 'search',
            eventaction: 'list to map click',
            eventlabel: 'button'
        });

        dispatch(routerActions.map());
    };

    return (
        <div className="MetaMapButton">
            <IconButton
                markup={LOCATION__16}
                onClick={handleMapButtonClick}
                data-wdio="map"
            >
                <FormattedMessage
                    id="mapButton"
                    description="Button to switch to map view"
                    defaultMessage="Map"
                />
            </IconButton>
        </div>
    );
};

export default MetaMapButton;
